import Link from 'next/link';
import PropTypes from 'prop-types';
import { readingTime } from 'reading-time-estimator';
import styles from './lcResourcesArticleItem.module.scss';
import SmartImage from '../smartImage/smartImage';

export default function LcResourcesArticleItem({
  category = {},
  publishedDate = '',
  subTitle = {},
  image = {},
  description = '',
  postContent,
}) {
  const stats = readingTime(postContent ?? '');
  const timeDuration = stats.text;
  const formatDate = new Date(publishedDate).toLocaleString('en-US', {
    timeZone: 'America/Los_Angeles',
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
  return (
    <div className={styles.articleContent}>
      <div className={styles.contentSection}>
        <div className={styles.subTitle}>
          <Link href={subTitle?.link}>{subTitle?.label}</Link>
        </div>
        <div className={styles.description}>{description}</div>
        <div className={styles.categorySection}>
          <div className={styles.category}>
            <Link href={category?.link}>{category?.label}</Link>
          </div>
          <div className={styles.date}>{formatDate}</div>
          {timeDuration && <div className={styles.time}>{timeDuration}</div>}
        </div>
      </div>
      {image && (
        <Link href={subTitle?.link}>
          <div className={styles.articleImage}>
            <SmartImage
              src={image}
              alt={image.alt}
              loading="lazy"
              height={image.height ?? 108}
              width={image.width ?? 108}
              quality={100}
            />
          </div>
        </Link>
      )}
    </div>
  );
}

LcResourcesArticleItem.propTypes = {
  category: PropTypes.shape({
    label: PropTypes.string,
    link: PropTypes.string,
  }),
  publishedDate: PropTypes.string,
  subTitle: PropTypes.shape({
    label: PropTypes.string,
    link: PropTypes.string,
  }),
  description: PropTypes.string,
  postContent: PropTypes.string,
  image: PropTypes.shape({
    src: PropTypes.string,
    alt: PropTypes.string,
  }),
};
